//INPUTS HANDLERS

var onSentBad = function () {

    },
    onSentOk = function(event){
        var eventID = event.detail.contactFormId;

        $('.full, .focus, .error').removeClass('focus full error');

        var submit = $('[id^=wpcf7-f'+ eventID +']').find('.wpcf7-form');

        setTimeout(function () {
            submit.removeClass('sent');
        }, 12000);

        var pd;
        pd = new FormData();
        pd.append('action', 'set_recipient');

        $.ajax({
            type: 'POST',
            url: for_ajax['admin'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (respond) {
                //console.log(respond);
            }
        });
    },
    onSubmit = function(event){
        var eventID = event.detail.contactFormId;
        var thisForm = $('[id^=wpcf7-f'+ eventID +']').find('.wpcf7-form');

        if(thisForm.hasClass('invalid')) {
            notValidForm(thisForm);
        }

        var input = $('.wpcf7').find('input, textarea, .wpcf7-checkbox');
        for (var i = 0; i < input.length; i++) {
            if (input.eq(i).hasClass('wpcf7-not-valid')) {
                // input.eq(i).next().animateCss('fadeInUp');
                input.eq(i).closest('.input').addClass('error');
            }
        }
    };


function notValidForm(form){
    var thisForm = form;
    var attr = thisForm.attr('data-submit');
    if (typeof attr !== typeof undefined && attr !== false) {
        var submitNum = parseInt(thisForm.attr('data-submit')) + 1;
        thisForm.attr('data-submit', submitNum);
        if (submitNum >= 3) {
            $('.formModal').addClass('active');
            $('.formModal--inner').addClass('active');
        }
    } else {
        thisForm.attr('data-submit', 1);
    }
}


$(document).on('wpcf7submit', onSubmit);
$(document).on('wpcf7mailsent', onSentOk);
$(document).on('wpcf7mailfailed', onSentBad);

var inputs = $('.wpcf7 textarea, .wpcf7 input:not([type="checkbox"])');

inputs.on('change keyup keydown keypress', function(){
    if ($.trim(this.value).length > 0) {
        var input = $(this);

        input.closest('.input, .file-div').addClass('full');

        input.next().animateCss('fadeOutDown', function () {
            input.next().remove();
        });

        input.removeClass('wpcf7-not-valid').closest('.input').removeClass('error');
    } else {
        $(this).closest('.input, .file-div').removeClass('full');
    }
});


var goodKey = '0123456789+ ';

var checkInputTel = function(e) {
    var key = (typeof e.which == "number") ? e.which : e.keyCode;
    var start = this.selectionStart,
        end = this.selectionEnd;

    var filtered = this.value.split('').filter(filterInput);
    this.value = filtered.join("");

    /* Prevents moving the pointer for a bad character */
    var move = (filterInput(String.fromCharCode(key)) || (key == 0 || key == 8)) ? 0 : 1;
    this.setSelectionRange(start - move, end - move);
}

var filterInput = function(val) {
    return (goodKey.indexOf(val) > -1);
}


$(document).on('focus', '.phone-number', function () {
    if ($(this).val() === '') {
        var cleave = new Cleave($(this), {
            blocks: [3, 5, 5, 5],
            uppercase: true
        });
    }
});

var telinput = document.querySelectorAll('.phone-number');

for (var i = 0; i< telinput.length; i++) {
    telinput[i].addEventListener('input', function () {
        var start = this.selectionStart;
        var end = this.selectionEnd;
        var current = this.value
        var corrected = current.replace(/([^0-9])/gi, '');
        this.value = corrected;

        if (corrected.length < current.length) --end;
        this.setSelectionRange(start, end);
    });
}

inputs.on('focusin', inputs, function(){
    $(this).closest('.input').addClass('focus');
    if($(this).parents('.input-block').length > 0) {
        $(this).parents('.input-block').addClass('focus');
    }
});

inputs.on('focusout', inputs, function(){
    $(this).closest('.input').removeClass('focus');
    if($(this).parents('.input-block').length > 0) {
        if($(this).val() === '') {
            $(this).parents('.input-block').removeClass('focus');
        }
    }
});

$('textarea').on('keyup', function () {
    var scrollHeight = $(this)[0].scrollHeight;
    var height = $(this).outerHeight();

    if(height < scrollHeight) {
        $(this).css('height', scrollHeight);

        if(scrollHeight > 200) {
            $(this).addClass('overflow');
        }
    }
});

if ($('.formModal').length > 0) {
    $('.formModal').click(function () {
        $('.formModal--inner').removeClass('active');
        setTimeout(function () {
            $('.formModal').removeClass('active');
        }, 500)
    });
    $('.formModal').click(function (e) {
        e.stopPropagation();
    });
    $('.formModal__messageBlock').click(function (e) {
        e.stopPropagation();
    });

    $('.formModal--close').click(function () {
        $('.formModal--inner').removeClass('active');
        setTimeout(function () {
            $('.formModal').removeClass('active');
        }, 500)
    });
}
